import * as React from 'react';
import { SVGProps } from 'react';

const IconPasteSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 0a1 1 0 0 0-1 1H6a1 1 0 0 0-1 1v2h6V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1-1z" />
    <path d="M4 2H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1v11.999H4V2z" />
    <path d="M5 8V7h6v1H5zm4 3v-1H5v1h4z" />
  </svg>
);
export default IconPasteSizeS;
